module.exports = __webpack_public_path__ + "media/images/sea_pat-2f994577cf04d1f6420a39f436ad42ff.png";